/**
 * Utility functions for the configurator components - cards
 */

/**
 * Load cards from the API
 * @param {String?} limit - The item to check
 * @param {Boolean} random - The item to check
 * @returns {Object} All cards available
 */
export async function loadCards(limit = null, random = false) {
  try {
    // Gepersonaliseerde kaarten worden altijd getoond, ongeacht de brievenbus keuze
    const searchParams = new URLSearchParams({});
    limit ? searchParams.append('limit', limit) : '';
    random ? searchParams.append('random', 'true') : '';
    const url =
      '/api/products/gepersonaliseerde-kaarten?' + searchParams.toString();

    const res = await fetch(url, {
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('Failed to load cards');
    let cards = await res.json();
    cards = cards.items;

    if (Array.isArray(cards)) {
      cards = cards.filter((card) => isValidCard(card));
      return cards;
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Error loading cards:', error);
    throw new Error('Failed to load cards');
  }
}

/**
 * Load cards from the API
 * @returns {Object} All cards available
 */
export function isValidCard(card) {
  return (
    card &&
    card.id &&
    card.name &&
    typeof card.price === 'number' &&
    card.price >= 0
  );
}
